import React from 'react';
import FundingReportMetricGrid, { buildSummaryMetrics } from './FundingReportMetricGrid';

const FundingExecutiveSummary = ({ data, loading }) => {
  if (loading) return <p className="text-sm text-[var(--fg-muted)]">Loading executive summary...</p>;
  if (!data) return <p className="text-sm text-[var(--fg-muted)]">No summary data available.</p>;

  return (
    <div className="space-y-4">
      <FundingReportMetricGrid metrics={buildSummaryMetrics(data)} />
      <p className="text-xs text-[var(--fg-muted)]">
        Amounts and commissions are estimated projections based on your current funding book. No funding guarantees.
      </p>
    </div>
  );
};

export default FundingExecutiveSummary;
